<template>
	<div id="alarm-form-content">
		<vs-row vs-w="12">
			<vs-col vs-lg="12" vs-sm="12" vs-md="12" vs-xs="12">
				<vx-card no-shadow card-border>
					<div class="vx-row">
						<div class="vx-col w-full md:w-1/3 sm:w-1/1">
							<!-- NAME -->
							<vs-input
								:label="$t('Name')"
								v-model="alarm_local.name"
								class="w-full"
								name="item-name"
								v-validate="'required'"
							/>
							<span class="text-danger text-sm" v-show="errors.has('item-name')">{{
								$t("Alarm.ValidFields.Name")
							}}</span>
						</div>

						<div class="vx-col w-full md:w-1/3 sm:w-1/1 mt-2">
							<small class="date-label">{{ $t("InitDate") }}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								name="initDate"
								v-validate="'validatorInitDate'"
								v-model="alarm_local.init_date"
								:disabledDates="disabledDatesTo"
							></datepicker>
							<span class="text-danger text-sm" v-show="errors.has('initDate')">{{
								$t("Alarm.DateInitError")
							}}</span>
						</div>

						<div class="vx-col w-full md:w-1/3 sm:w-1/1 mt-2">
							<small class="date-label">{{ $t("EndDate") }}</small>
							<datepicker
								:language="$vs.rtl ? langHe : langEn"
								:disabledDates="disabledDatesTo"
								v-validate="'validatorEndDate'"
								name="endDate"
								v-model="alarm_local.end_date"
							></datepicker>
							<span class="text-danger text-sm" v-show="errors.has('endDate')">{{
								$t("Alarm.DateInitError")
							}}</span>
						</div>

						<div class="vx-col w-full md:w-1/3 sm:w-1/1 mt-2">
							<div>
								<small class="date-label">{{ $t("Days") }}</small>
								<v-select
									class="w-full"
									:multiple="true"
									:closeOnSelect="false"
									v-model="alarm_local.days"
									:options="daysOptions"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
									:selectable="
										(option) =>
											!alarm_local.days.find((element) => element == $t('Alarm.SelectAll'))
									"
									v-on:input="changeRoute($event)"
								/>
							</div>
						</div>

						<div class="vx-col w-full md:w-1/3 sm:w-1/1 mt-2">
							<small class="date-label">{{ $t("InitHour") }}</small>
							<flat-pickr
								:config="configdateTimePicker"
								class="w-full"
								v-model="alarm_local.init_hour"
								:placeholder="$t('Alarm.SelectInitTime')"
								v-validate="'validatorInitHour'"
								name="dataHourInit"
							/>
							<span class="text-danger text-sm" v-show="errors.has('dataHourInit')">{{
								$t("Alarm.ValidInitHour")
							}}</span>
						</div>

						<div class="vx-col w-full md:w-1/3 sm:w-1/1 mt-2">
							<small class="date-label">{{ $t("EndHour") }}</small>
							<flat-pickr
								:config="configdateTimePicker"
								v-model="alarm_local.end_hour"
								class="w-full"
								:placeholder="$t('Alarm.SelectEndTime')"
								v-validate="'validatorEndHour'"
								name="dataHourEnd"
							/>
							<span class="text-danger text-sm" v-show="errors.has('dataHourEnd')">{{
								$t("Alarm.ValidEndHour")
							}}</span>
						</div>

						<div class="vx-col w-full md:w-1/3 mt-2">
							<small class="date-label">{{ $t("Follower.SelectLanguageText") }}</small>

							<v-select
								class="w-full"
								v-model="language"
								:options="languages"
								:clearable="false"
								:closeOnSelect="true"
								value="language_value"
								label="label"
								name="language_value"
								id="language_value"
							/>
						</div>

						<!-- AlarmSpeed-->

						<div class="vx-col md:w-1/1 mt-2" v-if="alarmType === 'AlarmSpeed'">
							<small class="date-label">{{ $t("Alarm.Speed") }} Km/h</small>
							<vs-input-number
								icon-inc="expand_less"
								icon-dec="expand_more"
								v-model="alarm_local.speed"
								min="0"
							/>
						</div>
					</div>

					<vs-divider class="d-theme-border-grey-light mb-base mt-base" />

					<div class="vx-row">
						<div class="vx-col w-full md:w-1/2 sm:w-1/1">
							<resource-assigned-list
								:resource_ids="resourceIds"
								:search="true"
								:pagination="true"
								v-if="assignateTo.value === 'resources'"
							></resource-assigned-list>
							<visit-point-assigned-list
								:visit_point_ids="visitPointsIds"
								v-if="alarmType === 'AlarmSchedule' && assignateTo.value === 'visitpoints'"
							></visit-point-assigned-list>
						</div>

						<div class="vx-col w-full md:w-1/2 sm:w-1/1">
							<vx-card
								no-shadow
								card-border
								class="custom-height"
								:title="$t('Alarm.AssignedEmails') + ' ' + emails_local.length"
							>
								<template slot="actions">
									<div class="flex flex-row justify-between">
										<vx-tooltip
											class="cursor-pointer"
											:title="$t('Alarm.DeleteEmails')"
											color="primary"
											position="bottom"
											:text="$t('Alarm.DeleteAllEmails')"
										>
											<vs-button
												id="btn-show-list-resources"
												icon-pack="feather"
												icon="icon-trash"
												@click.stop="deleteAll('EMAILS')"
											></vs-button>
										</vx-tooltip>
									</div>
								</template>

								<!-- Append Button -->
								<label class="vs-input--label" for="email">{{ $t("Email") }}</label>
								<vx-input-group class="mb-2">
									<vs-input
										type="email"
										v-model="email"
										id="email"
										name="email"
										@keypress.enter="addEmail"
										v-validate="'email|min:3'"
									/>
									<template slot="append">
										<div class="append-text btn-addon">
											<vs-button
												color="primary"
												@click="addEmail"
												:disabled="errors.has('email') || email === ''"
												>{{ $t("Add") }}
											</vs-button>
										</div>
									</template>
								</vx-input-group>

								<span class="text-danger text-sm" v-show="errors.has('email')">{{
									$t("Alarm.ValidFields.Email")
								}}</span>

								<vue-perfect-scrollbar class="scroll-email-area" :settings="settings">
									<vs-table max-items="100" :data="emails_local" v-if="emails_local.length > 0">
										<template slot="thead">
											<vs-th>N.</vs-th>
											<vs-th>{{ $t("Email") }}</vs-th>
											<vs-th>{{ $t("Actions") }}</vs-th>
										</template>

										<template slot-scope="{data}">
											<vs-tr :key="indextr" v-for="(tr, indextr) in data">
												<vs-td>
													{{ indextr + 1 }}
												</vs-td>

												<vs-td :data="data[indextr]">
													{{ data[indextr] }}
												</vs-td>

												<vs-td :data="data[indextr]">
													<feather-icon
														:title="$t('Crud.Delete')"
														size="small"
														icon="Trash2Icon"
														svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
														@click="delEmail(data[indextr])"
													/>
												</vs-td>
											</vs-tr>
										</template>
									</vs-table>
									<p v-else class="mt-base">
										{{ $t("Alarm.NoAssignedEmail") }}
									</p>
								</vue-perfect-scrollbar>
							</vx-card>
						</div>
					</div>
				</vx-card>
			</vs-col>
		</vs-row>

		<div class="vx-row">
			<div class="vx-col w-full">
				<div class="mt-8 flex flex-wrap items-center justify-end">
					<vs-button type="border" color="danger" @click="$emit('changeActiveTabEmit', 0)"
						>{{ $t("Cancel") }}
					</vs-button>
					<vs-button
						v-if="duplicate"
						id="btn-submit-alarm"
						class="ml-4 mr-6 vs-con-loading__container"
						@click="submitData"
						:disabled="!isFormValid"
						>{{ $t("Duplicate") }}
					</vs-button>
					<vs-button
						v-else
						id="btn-submit-alarm"
						class="ml-4 mr-6 vs-con-loading__container"
						@click="submitData"
						:disabled="!isFormValid"
						>{{ $t("Save") }}
					</vs-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import {en, es} from "vuejs-datepicker/src/locale";
import {Validator} from "vee-validate";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moduleGroup from "@/store/group/moduleGroup.js";
import moduleCommon from "@/store/common/moduleCommon.js";
import moduleResource from "@/store/resource/moduleResource.js";
import moduleZonification from "@/store/zonification/moduleZonification.js";
import moduleVisitPoint from "@/store/visit-point/moduleVisitPoint.js";
import ResourceAssignedList from "@/components/resource/user-list/ResourceAssignedList.vue";
import VisitPointAssignedList from "@/components/visit-point/list/VisitPointAssignedList.vue";
import PayloadContext from "@/models/PayloadContext";
import Commons from "@/helpers/commons.js";
import DateUtils from "@/helpers/DateUtils.js";
import cartoDB from "@/helpers/cartoDB";
import cartodb from "@/constants/cartodb.js";
import AlarmSpeed from "@/models/AlarmSpeed";

const {cartoTable} = cartodb;

export default {
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
		type: {
			type: String,
			default: "",
		},
		triggerCleanDates: {
			type: Number,
		},
		duplicate: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		VuePerfectScrollbar,
		flatPickr,
		vSelect,
		Datepicker,
		Treeselect,
		ResourceAssignedList,
		VisitPointAssignedList,
	},
	data() {
		return {
			selectAssignedResourcesZones: this.data.radius === 0,
			alarm_local: JSON.parse(JSON.stringify(this.data)),
			alarmType: this.type,
			email: "",
			activeItem: 0,
			disabledFrom: false,
			configdateTimePicker: {
				enableTime: true,
				enableSeconds: true,
				noCalendar: true,
			},
			langHe: es,
			langEn: en,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			days: [],
			daysOptions: ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"],

			resource_id: [],
			checkedResources: [],
			relatedIds: [],
			totalResources: 0,

			update: false,
			emails: [],

			zones: null,
			optionsMulti: [],
			//typeBatteryAlarm: null,
			zoneTypes: [
				{value: 1, label: "Entrada"},
				{value: 2, label: "Salida"},
				{value: 3, label: "Entrada y Salida"},
			],
			assignateTo: {value: "resources", label: this.$t("Resources")},
			assignateToOptions: [
				{value: "resources", label: this.$t("Resources")},
				{value: "visitpoints", label: this.$t("VisitPoints")},
			],
			radiusAlarmAssignateTo: {
				value: "zones",
				label: this.$t("Alarm.AssignedZones"),
			},
			radiusAlarmAssignateToOptions: [
				{value: "zones", label: this.$t("Alarm.AssignedZones")},
				{value: "radius", label: this.$t("Alarm.Radio")},
			],
			typeAlarmRadio: {value: 1, label: this.$t("Alarm.Start")},
			client: null,
			notFoundZone: false,
			resourceIds: [],
			visitPointsIds: [],
			language: {label: this.$t("Languages.Spanish"), language_value: "es_CO"},
		};
	},

	computed: {
		zoneTypes2() {
			return [
				{value: 1, label: this.$t("Alarm.Start")},
				{value: 2, label: this.$t("Alarm.End")},
				{value: 3, label: this.$t("Alarm.Startandend")},
			];
		},
		isFormValid() {
			return (
				!this.errors.any() &&
				(this.assignedResources.length > 0 || this.assignedVisitPoints.length > 0) &&
				this.alarm_local.days.length > 0 &&
				this.emails.length > 0 &&
				this.alarm_local.init_hour !== "" &&
				this.alarm_local.end_hour !== ""
			);
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		disabledDatesTo() {
			return {to: new Date(this.alarm_local.init_date)};
		},
		disabledDatesFrom() {
			return {from: new Date(this.alarm_local.init_date)};
		},
		assignedResources() {
			return this.$store.state.moduleResource.resourcesActivity;
		},
		assignedVisitPoints() {
			return this.$store.state.moduleVisitPoint.assignedVisitPoints;
		},
		emails_local() {
			return this.emails;
		},
		layerOptions() {
			return Commons.generateSelectOptios(this.$store.state.moduleZonification.layers, "name", "id");
		},
		typeBatteryAlarm: {
			get() {
				const typeBatteryAlarm = this.alarm_local.type_alarm || 1;
				return {
					value: typeBatteryAlarm,
					label: this.zoneTypes.find((t) => t.value === typeBatteryAlarm).label,
				};
			},
			set(val) {
				this.alarm_local.type_alarm = val.value;
			},
		},
		languages() {
			return [
				{label: this.$t("Languages.Spanish"), language_value: "es_CO"},
				{label: this.$t("Languages.English"), language_value: "en_US"},
				{label: this.$t("Languages.Portuguese"), language_value: "pt_BR"},
			];
		},
	},
	methods: {
		openLoadingBtn() {
			this.$vs.loading();
		},
		closeLoadingBtn() {
			this.$vs.loading.close();
		},

		changeRoute: function (a) {
			// If SelectAll is selected this delete other opcions selected and when sendData delete selectAll and send values
			if (this.alarm_local.days.find((element) => element == this.$t("Alarm.SelectAll"))) {
				if (this.alarm_local.days.find((element) => element !== this.$t("Alarm.SelectAll"))) {
					this.alarm_local.days = this.alarm_local.days.filter(
						(element) => element == this.$t("Alarm.SelectAll")
					);
				}
			}
		},
		deleteAll(value) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Alarm.DeleteAllText") + ` "${value}"`,
				accept: this.deleteAllEmails,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAllEmails() {
			this.emails = [];
		},
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		initValues() {
			const strategies = {
				AlarmSpeed,
			};

			const StrategyClass = strategies[this.alarmType];

			const payloadContext = new PayloadContext(null);

			payloadContext.setStrategy(new StrategyClass({}));

			if (this.update) {
				this.alarm_local = new StrategyClass(this.data);
			} else {
				this.alarm_local = payloadContext.getStrategy();
			}

			if (this.update) {
				this.getAssignedResources();
				this.language = this.languages.find((l) => l.language_value === this.alarm_local.language);
			}

			this.emails = [...this.alarm_local.email];
		},
		submitData() {
			this.alarm_local.resource_id = this.assignedResources.map((resource) => resource.id);
			this.alarm_local.init_date = DateUtils.toDefaultDateTime(this.alarm_local.init_date, "YYYY-MM-DD");
			this.alarm_local.end_date = DateUtils.toDefaultDateTime(this.alarm_local.end_date, "YYYY-MM-DD");
			this.alarm_local.email = this.emails.map((email) => email);
			this.alarm_local.language = this.language.language_value;

			// If selectAll is selected this create new object with all days

			if (this.alarm_local.days.find((element) => element == this.$t("Alarm.SelectAll"))) {
				var totalDays = new Array(
					...this.daysOptions.filter((element) => element !== this.$t("Alarm.SelectAll"))
				);
				var newAlarmObject = {};
				newAlarmObject = {...this.alarm_local};
				newAlarmObject.days = totalDays;

				this.$emit("handleSubmitEmit", newAlarmObject, this.update, this.duplicate);
			} else {
				this.$emit("handleSubmitEmit", this.alarm_local, this.update);
			}
		},
		cleanDates() {
			this.alarm_local.init_date = this.addDaysToDate(this.alarm_local.init_date, 1);
			this.alarm_local.end_date = this.addDaysToDate(this.alarm_local.end_date, 1);
		},
		/**
		 * @param{String} stringTime 01:00:45
		 */
		stringTimeToDate(stringTime) {
			let newDate = new Date();
			if (typeof stringTime === "string") {
				const [hours, minutes, seconds] = stringTime.split(":");
				newDate = new Date(1995, 11, 17, parseInt(hours), parseInt(minutes), parseInt(seconds));
			}
			return newDate;
		},
		removeError(errorName) {
			const index = this.errors.items.findIndex((e) => e.field === errorName);
			this.errors.items.splice(index, 1);
		},
		validatorInitDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const ih = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const eh =
				typeof this.alarm_local.end_date === "string"
					? new Date(this.alarm_local.end_date).getTime()
					: this.alarm_local.end_date.getTime();
			return ih <= eh;
		},
		validatorEndDate(value, args) {
			this.removeError("initDate");
			this.removeError("endDate");
			if (!value || value === "" || typeof value === "number") {
				return true;
			}
			const eh = typeof value === "string" ? new Date(value).getTime() : value.getTime();
			const ih =
				typeof this.alarm_local.init_date === "string"
					? new Date(this.alarm_local.init_date).getTime()
					: this.alarm_local.init_date.getTime();
			return eh >= ih;
		},
		validatorEndHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.alarm_local.init_hour === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) > this.stringTimeToDate(this.alarm_local.init_hour);
		},
		validatorInitHour(value, args) {
			this.removeError("dataHourInit");
			this.removeError("dataHourEnd");
			if (this.alarm_local.end_hour === "" || value === "") {
				return true;
			}
			return this.stringTimeToDate(value) < this.stringTimeToDate(this.alarm_local.end_hour);
		},
		getAssignedResources() {
			this.openLoading();
			const data = {
				ids: this.alarm_local.resource_id,
				fields: ["id", "name", "lastname", "username", "identification", "email"],
			};
			this.$store
				.dispatch("moduleResource/getResourcesByFilter", data, {
					component: "activitycreate",
				})
				.then((res) => {
					this.closeLoading();
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
					this.$vs.notify({
						color: "danger",
						title: this.$t("Alarm.ErrorGetResourceFilter.Title"),
						text: this.$t("Alarm.ErrorGetResourceFilter.Text"),
					});
				});
		},
		addEmail() {
			if (this.errors.has("email")) return;
			if (!this.emails_local.includes(this.email) && this.email.trim().length > 2) {
				this.emails.unshift(this.email.trim().toLowerCase());
				this.email = "";
				setTimeout(() => {
					this.errors.clear();
				}, 50);
			}
		},
		delEmail(email) {
			// Delete item from email local
			const index = this.emails.findIndex((e) => e === email);
			this.emails.splice(index, 1);
		},

		addDaysToDate(stringDate, dayNums) {
			// 1000 * 60 * 60 * 24 * 3
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
	},
	watch: {
		alarm_local(val) {
			if (val.radius === 0 && this.selectAssignedResourcesZones === false) {
				this.selectAssignedResourcesZones = true;
			}
		},
		selectAssignedResourcesZones(val) {
			if (val === true) {
				this.alarm_local.radius = 0;
			} else {
				this.alarm_local.radius = 1;
			}
		},

		zones(val) {
			if (val) {
				this.alarm_local.cartodb_id = val.value;
			}
		},
		typeBatteryAlarm(val) {
			if (val) {
				this.alarm_local.type_alarm = val.value;
			}
		},
		typeAlarmRadio(val) {
			if (val) {
				this.alarm_local.type_alarm = val.value;
			}
		},
		triggerCleanDates(val) {
			this.cleanDates();
		},
	},
	created() {
		// Create Custom Validators
		Validator.extend("validatorEndHour", this.validatorEndHour);
		Validator.extend("validatorInitHour", this.validatorInitHour);
		Validator.extend("validatorInitDate", this.validatorInitDate);
		Validator.extend("validatorEndDate", this.validatorEndDate);

		// register Module Group
		if (!moduleGroup.isRegistered) {
			this.$store.registerModule("moduleGroup", moduleGroup);
			moduleGroup.isRegistered = true;
		}
		// register Module Common
		if (!moduleCommon.isRegistered) {
			this.$store.registerModule("moduleCommon", moduleCommon);
			moduleCommon.isRegistered = true;
		}
		// register Module VisitPoint
		if (!moduleVisitPoint.isRegistered) {
			this.$store.registerModule("moduleVisitPoint", moduleVisitPoint);
			moduleVisitPoint.isRegistered = true;
		}
		// register Module Resource
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
		// register Module Zonification
		if (!moduleZonification.isRegistered) {
			this.$store.registerModule("moduleZonification", moduleZonification);
			moduleZonification.isRegistered = true;
		}

		if (!this.data.id) {
			this.$validator.reset();
			this.initValues();
		} else {
			this.update = true;
			this.initValues();
		}
	},
	mounted() {
		// Create new client
		this.client = cartoDB.client();

		// If prop data exist
		if (this.alarm_local.days.length) {
			if (this.alarm_local.days.length == this.daysOptions.length) {
				this.daysOptions.unshift(this.$t("Alarm.SelectAll"));
				this.alarm_local.days = [];
				this.alarm_local.days.push(this.$t("Alarm.SelectAll"));
			} else {
				this.daysOptions.unshift(this.$t("Alarm.SelectAll"));
			}
		} else {
			this.daysOptions.unshift(this.$t("Alarm.SelectAll"));
		}
	},
	beforeDestroy() {
		this.$store.dispatch("moduleResource/cleanResourceActivity");
	},
};
</script>

<style lang="scss" scoped>
#alarm-form-content {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: auto;
	height: 400px;
}

.scroll-email-area {
	margin: auto;
	width: auto;
	height: 300px;
}

.custom-height {
	width: 100%;
	height: 550px;
}
</style>
